"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BasicIcon = function (props) {
    var iconClass = props.iconClass, iconLabel = props.iconLabel, width = props.width, height = props.height;
    return (react_1.default.createElement("div", { className: "clearfix d-inline-block pbs icon-section", style: { width: width, height: height } },
        react_1.default.createElement("span", { className: "icon " + iconClass }),
        iconLabel && react_1.default.createElement("span", { className: "mls" },
            " ",
            iconLabel,
            " ")));
};
exports.default = BasicIcon;
